import { Button, Row } from 'antd';
import styled from 'styled-components';
import { APP_SHELL_THEME } from '@/styles/appShellTheme';

export const StyledRow = styled(Row)<{ step: number }>`
  margin-top: 20px;
  justify-content: ${({ step }) => (step ? 'space-between' : 'flex-end')};
`;

/** Secondary action on dark modal — subtle when disabled, same outline style when enabled. */
export const SaveAsDraftButton = styled(Button)`
  &.ant-btn-default:not(:disabled) {
    background: rgba(${APP_SHELL_THEME.overlayRgb}, 0.06) !important;
    border-color: ${APP_SHELL_THEME.panelBorder} !important;
    color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.92) !important;

    &:hover {
      background: rgba(${APP_SHELL_THEME.overlayRgb}, 0.1) !important;
      border-color: ${APP_SHELL_THEME.filterBorder} !important;
      color: ${APP_SHELL_THEME.text} !important;
    }

    &:active {
      background: rgba(${APP_SHELL_THEME.overlayRgb}, 0.14) !important;
      border-color: ${APP_SHELL_THEME.accent} !important;
      color: ${APP_SHELL_THEME.text} !important;
    }
  }

  &.ant-btn-default:disabled,
  &.ant-btn-default[disabled] {
    background: transparent !important;
    border-color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.1) !important;
    color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.28) !important;
    opacity: 1 !important;
    cursor: not-allowed;
  }
`;
